import { z } from "zod";

/**
 * Socket event: job-status-read-pc-{jobId}
 * Received during CAD2Image and IP Server extraction.
 */
export const extractProgressEventSchema = z.object({
	id: z.union([z.number(), z.string()]).nullable().optional(),
	jobDisciplineBuildingLevelFileId: z
		.union([z.number(), z.string()])
		.nullable()
		.optional(),
	percentage: z.union([z.number(), z.string()]).optional().default(0),
	message: z.string().optional().default(""),
	isIpServer: z.boolean().optional().default(false),
	isError: z.boolean().optional().default(false),
	error: z.boolean().optional(),
	isReady: z.boolean().optional().default(false),
	currentStep: z.union([z.number(), z.string()]).nullable().optional(),
	totalSteps: z.union([z.number(), z.string()]).nullable().optional(),
	disciplineId: z.number().nullable().optional(),
});

/**
 * Socket event: ip-server-labeling-{fileId}
 * Received after extraction completes for each level file. Carries one of three
 * mutually-exclusive completion flags depending on the pipeline used:
 *   - isDxfpFinished: legacy DXFP path (shouldUseMaverick = false)
 *   - isMavericFinished: Maverick serverless path
 *   - isPcMavericFinished: PC-Maverick serverless path
 */
export const ipServerLabelingEventSchema = z.object({
	labeling: z.array(z.unknown()).optional(),
	isDxfpFinished: z.boolean().optional(),
	isMavericFinished: z.boolean().optional(),
	isPcMavericFinished: z.boolean().optional(),
});

/**
 * Socket event: job-status-read-{jobId}-{jobStatusId}
 * Received during Bimify progress (Revit upload phase).
 */
export const bimifyProgressEventSchema = z.object({
	statusesTotal: z.union([z.number(), z.string()]),
	currentStatusNumber: z.union([z.number(), z.string()]),
	message: z.string().optional().default(""),
	uploadedRevitFile: z.boolean().optional(),
	status: z.string().optional(),
});
